import { api } from "services/restUtil";
import { apiQuery, infiniteApiQuery, PaginatedResponse } from "utils/queries";
import { LessonSession, LessonSessionStatus, MonitoringLessonSession } from "./model";

export const upcomingSessionsQuery = apiQuery<PaginatedResponse<LessonSession>>({
  key: "/sessions/lesson/upcoming",
});

type LastLessonPerStudentResponse = {
  last_lessons: Record<string, string>;
};

export const lastLessonPerStudentQuery = apiQuery<LastLessonPerStudentResponse>({
  key: "/sessions/lesson/last-per-student",
});

type CompletedSessionsQueryParams = {
  team_id?: string;
  member_id?: string;
  page?: number;
  size?: number;
};

export const completedSessionsQuery = infiniteApiQuery<
  LessonSession,
  CompletedSessionsQueryParams | void
>({
  path: "/sessions/lesson/completed",
  queryFn: (path, queryParams) => api.get(path, queryParams),
});

type FetchSessionArgs = {
  id: string;
};

export function fetchSession(args: FetchSessionArgs) {
  return api.get<LessonSession>(`/session/lesson/${args.id}`);
}

type SessionsForMonitoringParams = {
  from: string;
  to: string;
};

type SessionsForMonitoringResponse = {
  list: MonitoringLessonSession[];
};

export const sessionsForMonitoringQuery = apiQuery<
  SessionsForMonitoringResponse,
  SessionsForMonitoringParams,
  void,
  MonitoringLessonSession[]
>({
  key: "/sessions/lesson/monitoring",
  select: resp => resp.list,
});

type SearchSessionsParams = {
  search?: string;
  statuses?: LessonSessionStatus[];
  page?: number;
  size?: number;
  order?: "asc" | "desc";
  from?: string;
  to?: string;
};

export type SearchSessionsResponse = {
  list: LessonSession[];
  total_count: number;
};

export function searchSessions({ search, statuses, ...args }: SearchSessionsParams) {
  return api.get<SearchSessionsResponse>("/sessions/lesson", {
    ...args,
    contains: search || undefined,
    filter: statuses?.length ? `status;${statuses.join(",")}` : undefined,
  });
}

type SearchSessionsQueryParams = {
  contains?: string;
  statuses?: LessonSessionStatus[];
  order?: "asc" | "desc";
};

export const searchLessonSessionsQuery = infiniteApiQuery<
  LessonSession,
  SearchSessionsQueryParams | void
>({
  path: "/sessions/lesson",
  queryFn: (_path, queryParams) =>
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- the union's void arm needs it, which the rule does not see
    searchSessions({ search: queryParams?.contains, ...queryParams }),
});
